import { Typography } from '@breetometer/components';
import { BreadcrumbAngleIcon } from 'BreetAssets';
import { TableTooltip } from 'BreetComponents';

import type { IModalHeader } from '../helpers';

const ModalHeader = ({ handleBackLink, title, root }: IModalHeader) => {
	const backlinkClass = `cursor_pointer right-sheet_navigator${title === root || !root ? '_hide' : ''} svg-dark`;

	return (
		<div
			className='right-sheet_header bg-primary-500 border-bottom-dark-navy'
			data-testid='modal-header'
		>
			<BreadcrumbAngleIcon
				focusable
				onClick={handleBackLink}
				className={backlinkClass}
			/>

			<Typography
				as='h3'
				className='color-neutral-50 truncate'
			>
				<TableTooltip
					message={title}
					enabled={!!title}
				>
					{title}
				</TableTooltip>
			</Typography>
		</div>
	);
};

export default ModalHeader;
